$(function () {

    var scinet = Scinet || {};

    scinet.initReadMore = function () {

        $("[data-readmore]")
            .each(
                function (index, anchor) {

                    var $anchor = $(anchor),
                        // eval should be okay here - string is from the trusted source
                        options = eval("(" + $anchor.data("readmore") + ")"),
                        $block = $(options.block),
                        blockLineHeight = parseInt($block.css("line-height")),
                        additionalHeight = options.additionalHeight || 0,
                        maxHeight = (blockLineHeight * options.lines) + additionalHeight;

                    $anchor.attr("href", "javascript:void(0)");

                    if ($block.height() <= maxHeight) {
                        $anchor.hide();

                        return;
                    }

                    $anchor.show();

                    $block.height(maxHeight);
                    $block.addClass("collapsed");
                    $anchor.text(options.expandText);
                    $anchor.addClass("collapsed");

                    $anchor.on("click", 
                        function () {
                        
                            if ($anchor.hasClass("collapsed")) {
                                $anchor.text(options.collapseText);
                                $block.height("auto");
                            } else {
                                $block.height(maxHeight);
                                $anchor.text(options.expandText);
                            }

                            $anchor.toggleClass("collapsed");
                            $block.toggleClass("collapsed");
                        });
                });
    }

    scinet.initReadMore();
});
